import React, { useState } from 'react';
import { connect } from 'react-redux';
import NvItem from './Partials/NvItem';
import { clearChartItemList } from '../../BusinessMonitoringChartsSlice';

const NavigationMenu = (props) => {
    const [selectedItem, setSelectedItem] = useState('');
    //console.info('selectedItem', selectedItem);

    return (
        <>
            {
                !props.isAdminMode &&
                <a href='#' onClick={(e)=> handleMainClick(e)} className='main-item-wrapper'>ראשי</a>
            }
                                                
            {
                props.nvItemList?.map((item, index) => {
                    return <NvItem key={index} item={item} selectedItem={selectedItem} setSelectedItem={setSelectedItem} /> 

                })
            }        
        </>
    );

    function handleMainClick(e) {
        e.preventDefault();
        props.clearChartItemList();
    }

}

const mapStateToProps = (state) => {
    return { 
        isAdminMode: state.businessMonitoringChartsBlock.isAdminMode
    };
};
  
const mapDispatchToProps = { clearChartItemList };
  
export default connect(mapStateToProps, mapDispatchToProps)(NavigationMenu);